import type { ReactNode } from "react";
import { Box } from "@mui/material";
import { boardTokens } from "@/shared/theme";
import { EvaluationBar, type EvaluationBarProps } from "../EvaluationBar";
import { useEvaluationGutterWidth } from "./useEvaluationGutterWidth";

/** Keeps the board, overlays and evaluation aligned in fixed or fitted workspaces. */
export const BoardFrame = ({
  children,
  width = "100%",
  fit = false,
  evaluation,
}: {
  children: ReactNode;
  width?: number | string;
  fit?: boolean;
  evaluation?: Omit<EvaluationBarProps, "layout">;
}) => {
  const gutter = useEvaluationGutterWidth();
  return (
    <Box
      sx={{
        width: fit
          ? {
              xs: "100%",
              sm: `min(100cqw, calc(100cqh + ${boardTokens.evaluation.gutterWidth}px))`,
            }
          : typeof width === "number"
            ? width + gutter
            : width,
        maxWidth: "100%",
        minWidth: 0,
        mx: "auto",
        display: "flex",
        alignItems: "stretch",
      }}
    >
      <Box
        data-testid="evaluation-gutter"
        sx={{ width: gutter, flexShrink: 0, display: "flex", justifyContent: "center" }}
      >
        {evaluation && <EvaluationBar {...evaluation} layout="vertical-left" />}
      </Box>
      <Box sx={{ position: "relative", flex: 1, minWidth: 0, aspectRatio: "1" }}>{children}</Box>
    </Box>
  );
};
